<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="id"
        v-slot="{ validated, valid, errors }"
        slim
    >
        <rkm-form-group
            :invalid-feedback="errors[0]"
            :state="rules ? (validated ? valid : null) : null"
            :class="{ 'm-0': !label }"
        >
            <label
                v-if="label"
                :for="id"
            >
                {{ label + (rules && rules.required ? ' *' : '') }}
            </label>

            <rkm-input-group
                :append="append"
                :large="groupLarge"
                :prepend="prepend"
                :small="groupSmall"
            >
                <template v-if="!prepend && $slots.prepend" v-slot:prepend>
                    <slot name="prepend" />
                </template>

                <b-form-file
                    :disabled="disabled"
                    :id="id"
                    :multiple="multiple"
                    :size="size"
                    :state="rules ? (validated ? valid : null) : null"
                    :value="value"
                    :placeholder="placeholder"
                    :drop-placeholder="dropPlaceholder"
                    :browse-text="browseText"
                    :accept="accept"
                    @change="$emit('change', $event)"
                    @input="$emit('input', $event)"
                >
                </b-form-file>

                <template v-if="!append && $slots.append" v-slot:append>
                    <slot name="append" />
                </template>
            </rkm-input-group>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import { BFormFile } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate';

export default {
    components: { BFormFile, ValidationProvider },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
        id() {

            // TODO: Centralizar e a tratar melhor a string, removendo caracteres especiais, acentos, etc.
            const id = (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')

            return this.uniqueId(id)
        },
        rules() {

            return this.disabled ? null : this.validations
        }
    },
    props: {
        append: { type: String, default: null },
        disabled: { type: Boolean },
        groupLarge: { type: Boolean, default: false },
        groupSmall: { type: Boolean, default: false },
        label: { type: String },
        large: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false },
        name: { type: String },
        prepend: { type: String, default: null },
        small: { type: Boolean, default: false },
        state: { type: Boolean, default: null },
        validationMode: { type: String, default: 'lazy' },
        validations: { type: Object, default: null },
        value: { type: [ Array, File ] },
        accept: { type: String, default: '.jpg, .png, .pdf' },
        browseText: { type: String, default: 'Selecionar' },
        placeholder: { type: String, default: 'Nenhum arquivo selecionado' },
        dropPlaceholder: { type: String, default: 'Arraste e solte aqui...' }
    },
}
</script>